import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ChildActivationStart, Router } from '@angular/router';
import { AuthenticationService } from '../_services/authentication.service';
import { first } from 'rxjs/operators';
import { User } from '../_models';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  isAdmin: boolean = false;
  loginForm: FormGroup;
  loginFailed = false;
  loading:boolean = false;

  showContact = false;

  constructor(
    private fb: FormBuilder,
    private authenticationService: AuthenticationService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      username: [''],
      password: ['']
    })
  }

  onSubmit(){
    this.loading = true;
    let formData = this.isAdmin ? this.loginForm.getRawValue() : { password: this.loginForm.getRawValue().password };

    this.authenticationService.login(formData)
      .pipe(first())
        .subscribe({
          next: () =>{
            const user = this.authenticationService.userValue;
            switch(user.user.role_id) {
              case 1:
                // * Admin
                this.router.navigate(['/nip']);
                break;
              case 2:
                // * Tehnolog
                this.router.navigate(['/operations']);
                break;
              case 3:
                // * Prodavac
                this.router.navigate(['/nip']);
                break;
              case 4:
                // * Sef proizvodnje
                this.router.navigate(['/nip']);
                break;
              case 5:
                // * Radnik
                this.router.navigate(['/nip-worker']);
                break;
              default:
            }

          },
          error: error =>{
            this.loading = false;
            this.loginFailed = true;
          }
        })
  }

}
